import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {  }

  get(key: string) {
    if (isPlatformBrowser(this.platformId)) {
     return localStorage.getItem(key);
    }
  }

  set(key: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
       return localStorage.setItem(key, value);
    }
  }

  remove(key: string) {
    if (isPlatformBrowser(this.platformId)) {
       return localStorage.removeItem(key);
    }
  }

  clear() {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.clear();
    }
  }

  windowReference() {
    if (isPlatformBrowser(this.platformId)) {
      return window;
   }
  }
}
/*
import { Injectable, Inject } from '@angular/core';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';


@Injectable()
export class BrowserStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object, @Inject(LOCAL_STORAGE) private localStorage: any) {
    // constructor code
 }

  set(key: string, data: any): void {
    try {
      this.localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }
  get(key: string) {
    try {
      return JSON.parse(this.localStorage.getItem(key));
    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return null;
    }
  }
  remove(key: string) {
    return this.localStorage.removeItem(key);
  }

  clear() {
    return this.localStorage.clear();
  }
}*/
